import React, { Component } from "react";
import { Upload, Button, Icon, Progress, Table } from "@tinper/next-ui";
import { loadJS, request } from "@utils";
import render from 'ynf-core-engine/render';
import { ENV_RENDER_DESIGNER } from '@utils/constants'
import "./style/index.less";
import DetailTable from "./detailTable";
import { v4 as uuid } from 'uuid'

let num = 0;

const POLLING_INTERVAL = 2000;
export default class Import extends Component {
  state = {
    errorDetailVisible: false,
    modalVisible: false,
    uploadAlias: uuid(),
    asyncKey: "",
    errorDetail: "",
    successDetail: "",
    fileList: [],
    progressNow: 0,
    uploadFileMsg: "", // 上传失败文案
    isProcessFinished: false, // 是否上传完成
    isShowUploadProgress: false, // 上传进度
    timer: null,
    uploadInterrupt: false, // 上传中断
    errorInfo: {}, // 后端返回的映射关系,错误信息等
    percentage: 0,
    alive: true,
    totalCount: 0,
    successCount: 0,
    errorCount: 0,
    failInfos: []
  };

  columns = [
    {
      title: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A8007C', '序号', undefined, {returnDom: true, placement: 'top'}),
      dataIndex: "index",
      key: "index",
      width: 80,
      render (_text, _record, index) {
        return index + 1;
      }
    },
    { title: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A8007E', '页签', undefined, {returnDom: true, placement: 'top'}), dataIndex: "sheetName", key: "sheetName", width: 100 },
    { title: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A8007F', '字段', undefined, {returnDom: true, placement: 'top'}), dataIndex: "columnName", key: "columnName", width: 100 },
    { title: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A80081', '失败行号', undefined, {returnDom: true, placement: 'top'}), dataIndex: "row", key: "row", width: 100 },
    { title: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A80082', '失败原因', undefined, {returnDom: true, placement: 'top'}), dataIndex: "errorMessage", key: "errorMessage", width: 300 }
  ];

  getResourse = () => {
    // 协同js在加载中
    if (window.uploadFileLoading) {
      // 开启定时器
      const timer = setInterval(() => {
        // 如果uploadFileRef没了，说明组件重新挂载了，立即结束定时器，没必要继续执行了
        if (!this.uploadFileRef) {
          clearInterval(timer);
          return;
        }
        // 如果js加载完毕，清除定时器，并执行init
        if (!window.uploadFileLoading) {
          clearInterval(timer);
          this.init();
        }
      }, 100);
    } else {
      // 组件第一次挂载，加载标记设置成true
      window.uploadFileLoading = true;
      loadJS(`/iuap-apcom-file/ucf-wh/fileservice/web/fileservice-web.min.js`, "ybUploadFileservice", this.init, () => {
        let flag = false;
        window.YYCooperationBridge?.ready?.(() => {
          flag = true;
          // 加载成功，标记设置为false
          window.uploadFileLoading = false;
        });
        return flag;
      });
    }
  };

  init = () => {
    console.log("YYCooperationBridge----", window.YYCooperationBridge);
  };

  setModal = (visible = true) => {
    const { renderEnv } = this.props;
    const isDesigner = renderEnv === ENV_RENDER_DESIGNER;
    if (!isDesigner) {
      this.setState({ modalVisible: visible, fileList: [], errorDetailVisible: false }, () => {
        this.getResourse();
      });
    }
  };

  // 重置进度条
  resetProgress = (payload = {}) => {
    const { errorStats = [], progressNow = 0, uploadFileMsg = "", isProcessFinished = false, isShowUploadProgress, timer } = payload;

    this.setState({
      errorStats,
      progressNow,
      uploadFileMsg,
      isProcessFinished,
      isShowUploadProgress: !!isShowUploadProgress,
      timer,
      uploadInterrupt: false
    });
  };

  // 处理进度条动画
  handleProgressBar = () => {
    const { progressNow, isShowUploadProgress } = this.state;
    return isShowUploadProgress
      ? (
        <div className={"yb_import_progress_box"}>
          <span>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A80085', '上传文件并解析中，请稍后', undefined, {returnDom: true, placement: 'top'})}</span>
          <div className={"yb_import_progress"}>
            <Progress percent={progressNow} status="active" strokeColor={{ from: "#38c6ff", to: "#5f8ef9" }} strokeWidth={5} />
          </div>
        </div>
      )
      : null;
  };

  // 渲染导入弹窗内容
  renderChildren = () => {
    const { fileList, isProcessFinished, isShowUploadProgress, uploadFileMsg, errorStats } = this.state;
    const isActionOver = isProcessFinished && !isShowUploadProgress; // 点击了上传，并且上传已结束
    const isNoError = isActionOver && !uploadFileMsg && !errorStats?.length; // errorStatisticsKey为后端返回的
    const props = {
      name: "file",
      action: "",
      showUploadList: false,
      fileList,
      accept: ".xlsx,.xls,.zip", // 默认接受文件类型
      beforeUpload: this.handleBeforeUpload.bind(this),
      customRequest: this.doImgUpload
    };
    const filename = fileList[0]?.name
    return (
      <div>
        <div className="yb_import_title">{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A80080', '上传文件', undefined, {returnDom: true, placement: 'top'})}</div>
        <Upload {...props}>
          <Button shape="border">
            <Icon type="uf-upload" /> {lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A80084', '点击上传', undefined, {returnDom: true, placement: 'top'})}
          </Button>
        </Upload>
        {fileList.length > 0 && (
          <div className={"yb_import_list"}>
            {fileList.map(item => {
              return (
                <div className={"yb_import_item_box"} key={item.id}>
                  <span className={"yb_import_filename"} title={item.name}>
                    {item.name}
                  </span>
                  <div className={"yb_import_file_right"}>
                    {/* 上传进度 */}
                    {!isActionOver && this.handleProgressBar()}

                    {isActionOver && uploadFileMsg ? <span className={"yb_import_file_status"}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A8007A', '上传失败', undefined, {returnDom: true, placement: 'top'})}</span> : null}

                    {isActionOver && !uploadFileMsg ? <span className={"yb_import_success_status"}>{lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A8007B', '上传完成', undefined, {returnDom: true, placement: 'top'})}</span> : null}

                    <span className={"yb_import_close"} onClick={this.handleAbort}>
                      X
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {fileList.length > 0 && (
          <div className={"yb_import_bottom"}>
            {uploadFileMsg ? <div className={"yb_import_failmsg"}>{`${lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A80083', '失败原因：', undefined, {returnDom: true, placement: 'top'})}${uploadFileMsg}`}</div> : null}
            {isNoError
              ? (
                <div
                  className={"yb_import_successmsg"}
                  dangerouslySetInnerHTML={{
                    __html: lang.localeUuid('UID:P_LIB-WEB-YNF-FE_18AC0EF404380008', { filename }, '<%=filename%>无异常数据，可进行导入').replace(filename, '<span class=${"yb_import_filename"}>${filename}</span>')
                      // `<span class=${"yb_import_filename"}>${fileList[0]?.name}</span>无异常数据，可进行导入`//@notranslate
                  }}></div>
              )
              : null}

            {/* 经初步数据校验，<%=name%>无异常数据，可进行导入 */}
            {/* 展示异常数据 */}
            {errorStats?.length > 0 && this.errdetailChildren(errorStats)}
          </div>
        )}
      </div>
    );
  };

  getDisabledStatus = () => {
    const { fileList, isProcessFinished, isShowUploadProgress, uploadFileMsg, errorStats } = this.state;
    const isActionOver = isProcessFinished && !isShowUploadProgress; // 点击了上传，并且上传已结束
    const isNoError = isActionOver && !uploadFileMsg && !errorStats?.length; // errorStatisticsKey为后端返回的
    return {
      disabled: !(fileList.length > 0 && isNoError)
    };
  };

  // 取消上传
  handleAbort = async () => {
    // 取消后端校验轮询
    const { timer } = this.state;
    if (timer) clearInterval(timer);
    this.resetProgress({ timer });
    this.setState({ fileList: [] });
  };

  // 上传前事件
  handleBeforeUpload = async file => {
    this.resetProgress({
      isShowUploadProgress: true
    });
    // 只加载最新上传的文件
    const fileList = [file];
    this.setState({ fileList });
  };

  // 自定义上传: 上传到协同服务获取服务ID
  doImgUpload = v1 => {
    const { pageStore } = this.props;
    console.log('serviceCode', serviceCode)
    window.YYCooperationBridge.YYUploadFiles({
      files: [v1.file] || [],
      authId: pageStore?.params?.serviceCode,
      appCode: "u8c" || pageStore?.params?.ownDomain,
      businessId: pageStore?.params?.billNo, // 这里不使用详情页的billNo，为了避免协作套件上展示出来
      beforeUpload: file => {},
      onFailed: error => {
        console.log("come in onFailed--", error);
        this.setState({ uploadFileMsg: error?.message || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A8007D', '本地上传文件失败', undefined, {returnDom: true, placement: 'top'}) });
      },
      onSuccess: file => {
        console.log("onSuccess-file----", file);
        this.doUploadAction({
          fileId: file.id,
          fileName: file.file.name,
          importStatus: 1,
          objectId: pageStore?.params?.billNo,
          objectName: "u8c" || pageStore?.params?.ownDomain
        });
      }
    });
  };

  // 拿到服务ID，传给对应的领域服务
  doUploadAction = async params => {
    const { pageStore } = this.props;
    const asyncKey = `asyncImport_${uuid().replace(/-/g, "")}`;
    this.setState({ asyncKey });

    const res = await request(
      {
        method: "post",
        url: `/iuap-metadata-import/exceltrain/bill/billImport`,
        params: {
          feV: 6,
          currentDomainKey: pageStore?.params?.domainKey,
          terminalType: pageStore?.query?.terminalType,
          busiObj: pageStore?.params?.busiObj,
          asyncKey,
          billnum: pageStore?.params?.detailBillNo || pageStore?.params?.billNo
        },
        data: {
          ...params
        }
      },
      {
        proxy: false,
        rawResponse: false,
        handleErrCode: true
      }
    );
    if (res.code == 200) {
      setTimeout(async () => {
        this.checkProcess(res.data.infos[0]);
      }, 2000);
    } else {
      // res.errorDetail
      this.setState({ errorDetail: res.errorDetail });
    }
  };

  // 检查进度
  checkProcess = async ({ asyncKey, url }) => {
    const { pageStore } = this.props;
    const res = await request(
      {
        method: "post",
        url: `/iuap-metadata-import/exceltrain${url}`,
        params: {
          feV: 6,
          currentDomainKey: pageStore?.params?.domainKey,
          terminalType: pageStore?.query?.terminalType,
          busiObj: pageStore?.params?.busiObj,
          asyncKey
        }
      },
      {
        proxy: false,
        rawResponse: false,
        handleErrCode: true
      }
    );
    if (res.code == 200) {
      num = 0;
      this.setState({ progressNow: res.data.percentage });
      if (res.data.percentage == 100) {
        this.setState({
          uploadFileMsg: "",
          progressNow: 100,
          isProcessFinished: true,
          isShowUploadProgress: false
        });
      } else {
        const self = this;
        setTimeout(() => self.checkProcess({ asyncKey, url }), 2000);
      }
    } else {
      const errorStats = res?.data?.errorStats || [];
      if (errorStats.length > 0) {
        this.setState({
          errorCount: res?.data?.errorCount || 0,
          errorStats,
          isProcessFinished: true,
          isShowUploadProgress: false
        });
      } else {
        // 连续三次请求报错后，再抛出错误信息
        num = num + 1;
        if (num >= 3) {
          this.setState({
            uploadFileMsg: res?.message || "",
            errorStats,
            errorCount: res?.data?.errorCount || 0,
            isProcessFinished: true,
            isShowUploadProgress: false
          });
        } else {
          const self = this;
          setTimeout(() => self.checkProcess({ asyncKey, url }), 2000);
        }
      }
    }
  };

  // 导入触发
  importAction = async () => {
    const { pageStore } = this.props;
    const { asyncKey } = this.state;
    const res = await request(
      {
        method: "post",
        url: `/iuap-metadata-import/exceltrain/dispatchImportTask`,
        params: {
          feV: 6,
          currentDomainKey: pageStore?.params?.domainKey,
          terminalType: pageStore?.query?.terminalType,
          busiObj: pageStore?.params?.busiObj
          // designPreview: true
        },
        data: {
          asyncKey,
          billNo: pageStore?.params?.detailBillNo || pageStore?.params?.billNo,
          currentDomainKey: pageStore?.params?.domainKey
        }
      },
      {
        proxy: false,
        rawResponse: false,
        handleErrCode: true
      }
    );
    if (res.code == 200) {
      setTimeout(async () => {
        this.setModal(false);
        this.importFile(res.data.infos[0]);
      }, 2000);
    } else {
      this.setState({ errorDetail: res.message });
    }
  };

  toDrew = async ({ asyncKey, url }) => {
    const { pageStore } = this.props;
    return await request(
      {
        method: "get",
        // /import/progress/draw
        url: `/iuap-metadata-import/exceltrain${url}`,
        params: {
          feV: 6,
          currentDomainKey: pageStore?.params?.domainKey,
          terminalType: pageStore?.query?.terminalType,
          busiObj: pageStore?.params?.busiObj,
          asyncKey
        }
      },
      {
        proxy: false,
        rawResponse: false,
        handleErrCode: true
      }
    );
  };

  // 执行导入轮询
  importFile = async ({ asyncKey, url }) => {
    const { pageStore, target } = this.props;
    let batchResolve;
    const batchPromise = new Promise(resolve => {
      batchResolve = resolve;
    });
    // quantum.utils.info("任务已转入后台，可进行其他操作");
    const polling = () => {
      setTimeout(async () => {
        const res = await this.toDrew({ asyncKey, url });
        const percentage = Number(res.data?.percentage);
        if (!isNaN(percentage)) {
          await this.setState({ percentage }, () => {
            this.displayProgress();
            console.log("进度改变111", this.state.percentage);
          });
          if (percentage === 100) {
            this.setState({ alive: false }, () => {
              setTimeout(() => {
                this.displayProgress();
              }, 2000);
            });
            if (res.data) {
              res.data.successCount = res.data?.successCount || 0;
              res.data.failCount = res.data?.errorCount || 0;
              res.data.failInfos = res.data?.errors || [];
              res.data.message = res.data?.message || [];
              res.data.actionType = lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A80079', '导入', undefined, {returnDom: true, placement: 'top'});
              res.data.cBillName = pageStore?.params?.billName;
              res.data.afterOkClick = () => {
                this.setState({
                  errorDetailVisible: true,
                  totalCount: res.data?.totalCount,
                  successCount: res.data?.sucessCount || 0,
                  errorCount: res.data?.errorCount || 0,
                  failInfos: res.data?.errors || []
                });
              };
            }
            // TODO:
            // quantum.utils.batchMsg(res.data);
            // ybTools.Filter.query({ pageStore, modelPath: [target] });
            return batchResolve();
          }
        }
        polling();
      }, POLLING_INTERVAL);
    };
    polling();
    await batchPromise;
  };

  displayProgress = ({ duration = 1000 } = {}) => {
    const FloatProgress = () => {
      const { percentage, alive } = this.state;
      if (!alive) return null;
      return <Progress type="circle" percent={percentage} width={50}></Progress>;
    };
    let progressHost = document.querySelector(".qtm-float-progress");
    if (!progressHost) {
      progressHost = document.createElement("div");
      progressHost.className = "qtm-float-progress";
      document.body.appendChild(progressHost);
    }
    ReactDOM.render(<FloatProgress />, progressHost);
  };

  errdetailChildren = errorStats => {
    const { pageStore } = this.props
    const { fileList, errorCount: count } = this.state;
    const filename = fileList[0]?.name
    const errorCount = count || 0
    return (
      <div className={"yb_import_content"}>
        <div className={"yb_import_top"}>
          {/* 经初步数据校验，<%=name%>存在<%=len%>处异常，明细如下： */}
          <div
            className={"yb_import_title"}
            dangerouslySetInnerHTML={{
              __html: lang.localeUuid('UID:P_LIB-WEB-YNF-FE_18AC0E3804480007', { filename, errorCount }, '经初步数据校验，<%=filename%>存在<%=errorCount%>处异常，明细如下：').replace(filename, '<span class=${"yb_import_filename"}>${filename}</span>').replace(errorCount, '<span class=${"yb_import_error_text"}>${errorCount}</span>')
              //   `经初步数据校验，<span class=${"yb_import_filename"}>${fileList[0]?.name}</span>存在<span class=${"yb_import_error_text"}>${//@notranslate
              //   errorCount || 0
              // }</span>处异常，明细如下：`//@notranslate
            }}></div>
          {/* <Button fieldid={`${this.getFieldId()}`} onClick={this.handleExport} model={this.vm} >
              导出异常原因
            </Button> */}
        </div>
        <div className={"yb_import_abnormal"}>
          <DetailTable errorStats={errorStats}></DetailTable>
          {/* <Table fieldid={`${this.getFieldId()}`} noViewModel model={this.gridModel} width={900} autoHeight={false} height={190} /> */}
        </div>
      </div>
    );
  };

  errdetailResult = () => {
    const { pageStore } = this.props
    const { totalCount = 0, successCount = 0, errorCount = 0, failInfos = [] } = this.state;
    return (
      <div className={"yb_import_content"}>
        <div className={"yb_import_top"}>
          <div
            className={"yb_import_title"}
            dangerouslySetInnerHTML={{
              __html: lang.localeUuid('UID:P_LIB-WEB-YNF-FE_18AC0D4C04380006', { totalCount, successCount, errorCount }, '共处理<%=totalCount%>条数据，成功<%=successCount%>条数据，失败<%=errorCount%>条数据。请查看错误原因，修改后重新导入。')
                // `共处理${totalCount}条数据，成功${successCount}条数据，失败${errorCount}条数据。请查看错误原因，修改后重新导入。`//@notranslate
            }}></div>
          {/* <Button fieldid={`${this.getFieldId()}`} onClick={this.handleExport} model={this.vm} >
              导出异常原因
            </Button> */}
        </div>
        <div className={"yb_import_abnormal"}>
          <Table className="child-table" columns={this.columns} data={failInfos} />
          {/* <Table fieldid={`${this.getFieldId()}`} noViewModel model={this.gridModel} width={900} autoHeight={false} height={190} /> */}
        </div>
      </div>
    );
  };

  getFieldId = () => {
    const { fieldid, fieldidPrefix } = this.props || {};
    return fieldid || fieldidPrefix;
  };

  render () {
    const { modalVisible, errorDetailVisible } = this.state;
    const modalConfig = {
      libCode: "ynf-fw-apcom-lib",
      controlType: "CommonPicker",
      width: "950px",
      height: "450px",
      title: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A80088', '导入工作台', undefined, {returnDom: true, placement: 'top'}),
      okText: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A80079', '导入', undefined, {returnDom: true, placement: 'top'}),
      alias: uuid(),
      className: "import-modal",
      okClick: () => {
        // 导入接口
        this.importAction();
      },
      close: () => {
        return new Promise((resolve, _reject) => {
          setTimeout(() => {
            this.setState({ modalVisible: false });
            resolve(true);
          }, 100);
        });
      },
      visible: modalVisible,
      okButtonProps: this.getDisabledStatus()
    }
    const errConfig = {
      libCode: "ynf-fw-apcom-lib",
      controlType: "CommonPicker",
      width: "950px",
      height: "450px",
      title: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A80086', '批量操作', undefined, {returnDom: true, placement: 'top'}),
      okText: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A80087', '确定', undefined, {returnDom: true, placement: 'top'}),
      alias: uuid(),
      className: "import-error-modal",
      okClick: () => {
        this.setState({ errorDetailVisible: false });
      },
      close: () => {
        return new Promise((resolve, _reject) => {
          setTimeout(() => {
            this.setState({ errorDetailVisible: false });
            resolve(true);
          }, 100);
        });
      },
      visible: errorDetailVisible
    }
    return (
      <div className="yb_import" ref={e => (this.importRef = e)}>
        <Button fieldid={`${this.getFieldId()}`} className="yb_import_btn" onClick={this.setModal} size="large" shape="block" bordered={true}>
          {lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A2282E05A80079', '导入', undefined, {returnDom: true, placement: 'top'})}
        </Button>
        {render(modalConfig, {
          children: this.renderChildren()
        })}
        {render(errConfig, {
          children: this.errdetailResult()
        })}
      </div>
    );
  }
}
